import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Modal, Input, Text, H4, Table, Badge } from '@bigcommerce/big-design';
import LoadingSpinner from '../../partials/LoadingSpinner';

const SuggestionItemsModal = ({ payload, showSuggestionItemsModal, setShowSuggestionItemsModal, suggestedPurchaseOrder }) => {
  const update = () => {
    setShowSuggestionItemsModal(false);
  }

  const tableItems = () => {
    let items = [];

    if(suggestedPurchaseOrder) {
      let variant = null;
      let product = null;

      suggestedPurchaseOrder.suggested_purchase_order_lines.suggested_purchase_order_lines.forEach(lineItem => {
        variant = null;
        product = null;

        if(lineItem.variant_id) {
          variant = suggestedPurchaseOrder.suggested_purchase_order_lines.variant_data.find(variant_data => variant_data.id === parseInt(lineItem.variant_id));
          product = suggestedPurchaseOrder.suggested_purchase_order_lines.related_product_data.find(prod => prod.id === parseInt(lineItem.product_id));
        } else {
          product = suggestedPurchaseOrder.suggested_purchase_order_lines.product_data.find(prod => prod.id === parseInt(lineItem.product_id));
        }

        items.push({
          name: product?.name || 'Product not found',
          supplier_sku: lineItem?.supplier_sku,
          stock_quantity: lineItem?.stock_quantity || 0,
          on_order_quantity: lineItem?.on_order_quantity || 0,
          recommended_quantity: lineItem?.recommended_quantity,
          is_critical: lineItem?.is_critical
        })
      })

    }

    return items;
  }

  return(
    <Modal
      actions={[
        {
          text: 'Close',
          variant: 'subtle',
          onClick: () => setShowSuggestionItemsModal(false),
        }
      ]}
      closeOnClickOutside={true}
      closeOnEscKey={true}
      header="Purchase Order Items"
      isOpen={showSuggestionItemsModal}
      onClose={() => setShowSuggestionItemsModal(false)}
    >
      <H4>Suggested PO Items</H4>
      { suggestedPurchaseOrder && suggestedPurchaseOrder?.suggested_purchase_order_lines &&
        <Table
          columns={[
            { header: 'Name', hash: 'name', render: ({ name }) => name },
            { header: 'Suppl. SKU', hash: 'supplier_sku', render: ({ supplier_sku }) => supplier_sku },
            { header: 'On Hand', hash: 'stock_quantity', render: ({ stock_quantity }) => stock_quantity, align: 'right' },
            { header: 'On Order', hash: 'on_order_quantity', render: ({ on_order_quantity }) => on_order_quantity, align: 'right' },
            { header: 'Rec. Qty', hash: 'recommended_quantity', render: ({ recommended_quantity, is_critical }) => (<Text color={is_critical ? 'danger' : 'warning'}>{recommended_quantity}</Text>), align: 'right' },
          ]}
          items={tableItems()}
          stickyHeader
        />
      }
      { !suggestedPurchaseOrder &&
        <LoadingSpinner statusText="Loading suggested purchase order" />
      }
    </Modal>
  )
}

export default SuggestionItemsModal;